'use client';

import ContentfulRichText from '@flipster/features/src/shared/contentful-rich-text';
import { Accordion } from '@flipster/features/src/shared/faq-accordion';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import segment, { marketingEventEvent } from '@flipster/utils/segment';

import { MaxWidthSection } from '@web/app/[locale]/(web)/campaign/_section/_layout';
import type { CampaignFaqItemFragment } from '@web/app/[locale]/(web)/campaign/query.generated';

interface FaqProps {
  faqs?: (CampaignFaqItemFragment | null)[];
}

export const Faq = ({ faqs }: FaqProps) => {
  if (!faqs?.length) return null;

  return (
    <MaxWidthSection sectionType='faq'>
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
          textAlign: { base: 'center', tablet: 'left' },
        })}
      >
        <FormattedMessage id='Common.r251104.Frequently_asked_questions' />
      </h2>
      <Accordion.Root headingLevel={3} css={{ mt: { base: 32, tablet: 40 } }}>
        {faqs.map((faq, index) => {
          if (!faq) return null;
          return (
            <Accordion.Item key={faq.sys.id}>
              <Accordion.Header
                index={index + 1}
                onExpanded={() =>
                  segment.track(marketingEventEvent.faqOpen, {
                    faq_title: faq.title ?? 'unknown',
                    list_order: index,
                  })
                }
              >
                {faq.title}
              </Accordion.Header>
              <Accordion.Panel>
                {faq.description && <ContentfulRichText richTextDocument={faq.description} />}
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion.Root>
    </MaxWidthSection>
  );
};
